var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXcirclefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.5300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.5254 85.6934-35.2539C85.6934-56.9824 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-56.9824 6.83594-35.2539C6.83594-13.5254 24.5117 4.15039 46.2402 4.15039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3262-16.9434C32.4707-16.9434 31.0059-18.3105 31.0059-20.1172C31.0059-21.0449 31.2012-21.6309 31.7871-22.4609L41.748-35.9375L32.4707-48.4375C31.6895-49.4629 31.4453-50.0488 31.4453-51.0742C31.4453-52.9297 33.1055-54.4434 35.0098-54.4434C36.5234-54.4434 37.4512-53.9062 38.4766-52.4414L46.582-40.8203L46.7773-40.8203L54.7363-52.3926C55.7129-53.9062 56.5918-54.4434 58.0078-54.4434C59.9121-54.4434 61.4258-53.0762 61.4258-51.2207C61.4258-50.4395 61.1816-49.6582 60.5469-48.8281L50.6836-35.6934L60.498-22.6562C61.084-21.8262 61.3281-21.1914 61.3281-20.2637C61.3281-18.3105 59.8145-16.9434 57.7637-16.9434C56.3477-16.9434 55.5664-17.4805 54.3945-19.0918L46.1426-30.6152L45.9961-30.6152L37.6953-19.0918C36.5234-17.4805 35.791-16.9434 34.3262-16.9434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcirclefill);
export default __webpack_public_path__ + "static/media/x.circle.fill.7bf694bcf7b6c7601e806c5aec6d0381.svg";
export { ForwardRef as ReactComponent };